import React from 'react';
import {sx} from "./sx";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import DoubleArrowLeftIcon from "@resource/svg/DoubleArrowLeftIcon";
import {Paper} from '@mui/material';

interface IProps {
    onShowSidebar: () => void,
    buttonVariantToggleShow?: 'absolute' | 'static'
}

const SidebarPanelHeaderUi = ({
                                  onShowSidebar,
                                  buttonVariantToggleShow
                              }: IProps) => {

    if (buttonVariantToggleShow === 'absolute') {
        return (
            <IconButtonCustom
                onClick={onShowSidebar}
                color={'#F5F3F0'}
                sx={sx.btn}
            >
                <DoubleArrowLeftIcon/>
            </IconButtonCustom>
        )
    }

    return (
        <Paper
            sx={sx.header}
        >
            <IconButtonCustom
                onClick={onShowSidebar}
                color={'#F5F3F0'}
            >
                <DoubleArrowLeftIcon/>
            </IconButtonCustom>
        </Paper>
    );
};

export default SidebarPanelHeaderUi;